export const PROPERTY_SUBMODULES = [
  'properties_approval_requests',
  'properties_approved',
  'properties_subscribed',
  'properties_purchased',
  'properties_rejected',
];

export const PERMISSION_RESOURCES = [
  'admins',
  'roles',
  'investors',
  'agents',
  'property_managers',
  'properties',
  ...PROPERTY_SUBMODULES,
  'issuer',
  'payment_configuration',
  'market_management',
  'property_financials',
  'comparable_property',
  'cashflow',
  'transactions',
  'portfolio',
  'investor_relations',
  'fee_master',
  'notification_settings',
];

export const PERMISSION_METADATA = [
  {
    resource: 'properties',
    label: 'Properties (All)',
    description: 'Manage all properties (view, approve, reject, update, hide).',
  },
  {
    resource: 'properties_approval_requests',
    label: 'Properties - Approval Requests',
    description: 'Access properties awaiting approval.',
  },
  {
    resource: 'properties_approved',
    label: 'Properties - Approved',
    description: 'Access approved properties.',
  },
  {
    resource: 'properties_subscribed',
    label: 'Properties - Subscribed',
    description: 'Access subscribed/funded properties.',
  },
  {
    resource: 'properties_purchased',
    label: 'Properties - Purchased',
    description: 'Access purchased/closed properties.',
  },
  {
    resource: 'properties_rejected',
    label: 'Properties - Rejected',
    description: 'Access rejected properties.',
  },
  {
    resource: 'investors',
    label: 'Investors',
    description: 'Manage investors (view, update status, delete).',
  },
  {
    resource: 'agents',
    label: 'Agents',
    description: 'Manage agents (view, update status, verify).',
  },
  {
    resource: 'property_managers',
    label: 'Property Managers',
    description: 'Manage property managers (view, create, update, delete).',
  },
  {
    resource: 'admins',
    label: 'Admins',
    description: 'Manage admin users (view, create, update, change status).',
  },
  {
    resource: 'roles',
    label: 'Roles',
    description: 'Manage role definitions and permissions.',
  },
  {
    resource: 'issuer',
    label: 'Issuer',
    description: 'Manage issuer configurations and settings.',
  },
  {
    resource: 'payment_configuration',
    label: 'Payment Configuration',
    description: 'Manage payment configurations and settings.',
  },
  {
    resource: 'market_management',
    label: 'Market Management',
    description: 'Manage market listings and market-related settings.',
  },
  {
    resource: 'property_financials',
    label: 'Property Financials',
    description: 'Manage property financial data and reports.',
  },
  {
    resource: 'comparable_property',
    label: 'Comparable Property',
    description: 'Manage comparable property analysis.',
  },
  {
    resource: 'cashflow',
    label: 'Cashflow',
    description: 'Manage rental cashflow cycles and payouts.',
  },
  {
    resource: 'transactions',
    label: 'Transactions',
    description: 'Manage platform transactions.',
  },
  {
    resource: 'portfolio',
    label: 'Portfolio',
    description: 'Manage user portfolios and holdings.',
  },
  {
    resource: 'investor_relations',
    label: 'Investor Relations',
    description: 'Manage investor relations and referrals.',
  },
  {
    resource: 'fee_master',
    label: 'Fee Master',
    description: 'Manage platform and property management fees.',
  },
  {
    resource: 'notification_settings',
    label: 'Notification Settings',
    description: 'Manage notification settings and broadcasts.',
  },
];

export const PROPERTY_STATUS_PERMISSION_MAP = {
  approval_requests: 'properties_approval_requests',
  approval: 'properties_approval_requests',
  submitted: 'properties_approval_requests',
  under_review: 'properties_approval_requests',
  draft: 'properties_approval_requests',
  pending: 'properties_approval_requests',
  approved: 'properties_approved',
  live: 'properties_approved',
  active: 'properties_approved',
  subscribed: 'properties_subscribed',
  funded: 'properties_subscribed',
  purchased: 'properties_purchased',
  closed: 'properties_purchased',
  rejected: 'properties_rejected',
};

export const getPropertyPermissionForStatus = (status) => {
  if (!status) return null;
  const key = String(status).trim().toLowerCase();
  return PROPERTY_STATUS_PERMISSION_MAP[key] || null;
};
